import React from 'react';
import { FDStack, FDTitleText } from '@facet-wealth/design';
import moment from 'moment';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MeetingInformationTooltip from 'Components/UI/MeetingInformation/MeetingInformationTooltip';

const ReadOnlyView = ({ meetingResource, householdResource, className }) => {
  const agendaMessageDate = moment(meetingResource.attr('startTime')).subtract(3, 'days');
  let sentMessage = `This household will be sent their meeting agenda for this meeting ${agendaMessageDate.format('dddd, MMMM Do YYYY')}`;
  if (moment().isAfter(agendaMessageDate)) {
    sentMessage = 'This household should have been sent their meeting agenda for this meeting. Please check their messages';
  }
  return (
    <Box className={className} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <FDStack direction={'column'} width={'100%'} minHeight={'100%'} justifyContent={'center'} alignItems={'center'} spacing={4}>
        <FDStack direction={'column'} alignItems={'center'} spacing={2}>
          <FDTitleText size={'lg'} value={'Meeting Agendas for PM1 and PM2 are automatically sent to the household 3 days before meeting start'} />
          <FDTitleText size={'md'} value={sentMessage} />
        </FDStack>
        <MeetingInformationTooltip meetingResource={meetingResource} householdResource={householdResource} />
      </FDStack>
    </Box>
  );
};

ReadOnlyView.defaultProps = {
  className: '',
};

ReadOnlyView.propTypes = {
  meetingResource: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export { ReadOnlyView };
